<template>
  <div>
    <!-- threejs renderer -->
    <div class="d-flex justify-center">
      <div class="responsive-width d-flex">
        <OneModelCard class="model-card mx-4" :modelIndex="modelIndex" :width="500" :height="500"></OneModelCard>
      </div>
      <div>
        <v-btn @click="onClickDownload">다운로드</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  mounted() {},
  data() {
    return {
      modelIndex: "bear",
    };
  },

  methods: {
    onClickDownload() {
      const modelIndex = this.modelIndex;
      window.__bool = true;
      window.render();
      this._downloadBase64File("image/png", window.__imgData, `${modelIndex}_thumbnail.png`);
    },
    _downloadBase64File(contentType, base64Data, fileName) {
      // const linkSource = `data:${contentType};base64,${base64Data}`;
      const linkSource = base64Data;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },
  },
};
</script>

<style></style>
